import { ReviewEntriesViewFilter } from '../../../enums/reviewEntriesViewFilter'

export type ReviewEntriesEmptyRowKind = 'empty-queue' | 'error' | 'filtered'

interface GetReviewEntriesEmptyRowInfoProps {
  filteredRowCount: number
  hasNarrowingFilters: boolean
  isError: boolean
  isLoading: boolean
  sourceRowCount: number
  viewFilter: ReviewEntriesViewFilter
}

export const getReviewEntriesEmptyRowInfo = ({
  filteredRowCount,
  hasNarrowingFilters,
  isError,
  isLoading,
  sourceRowCount,
  viewFilter,
}: GetReviewEntriesEmptyRowInfoProps): ReviewEntriesEmptyRowKind | undefined => {
  if (isError) {
    return 'error'
  }

  if (isLoading || filteredRowCount > 0) {
    return undefined
  }

  const isToValidateFilterEmpty = viewFilter === ReviewEntriesViewFilter.ToValidate && !hasNarrowingFilters

  if (sourceRowCount === 0 || isToValidateFilterEmpty) {
    return 'empty-queue'
  }

  return 'filtered'
}
